import React, { useState } from "react";

const LazyYoutube = ({ videoId, title }) => {
  const [load, setLoad] = useState(false);

  return (
    <div className="youtube-wrapper">
      {!load ? (
        <button
          className="youtube-poster"
          onClick={() => setLoad(true)}
          aria-label={`Play video ${title}`}
        >
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt={title}
            loading="lazy"
          />
          <span className="play-button"></span>
        </button>
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title={title}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default LazyYoutube;
